export default __webpack_public_path__ + "static/media/tick.feec63d7.svg";